<template>
	<div class="tap" @click="tap()"></div>
	<div class="marg-logo" v-if="design === 'margaritaville'">
		<icon-component iconName="logoRainbow" class="logo margaritaville-logo" />
	</div>
	<div class="pos-t">
		<div :id="'root-wr'">
			<div v-if="design === 'ecruise'" class="img-wrapper">
				<icon-component iconName="mainLogo" class="logo" />
			</div>
			<div class="flex-row">
				<div class="auth-type crew-id">
					<div class="auth-form-wrapper">
						<h2 class="title">Authorize</h2>

            <div
              v-if="isSwitchProcessed || (hasSelectedDepartment && posName?.length > 0)"
              class="current-department">
              <span class="form-field__label">Department</span>

              <div class="current-department__item">
                <span class="current-department__name">
                  {{ isSwitchProcessed ? oldPosName : posName }}
                </span>

                <button
                  v-if="hasSelectedDepartment"
                  :class="['current-department__switch', { 'selected': needSwitch }]"
                  @click.prevent="needSwitch = !needSwitch"
                >
                  SWITCH
                </button>
              </div>
            </div>

						<form id="1111" class="auth-form">
							<div class="type-radio" v-if="!useMagneticScannerValue">
								<div class="radio-wrapper" @click="inFocus = 'barcode'">
									<icon-component :iconName="inFocus === 'barcode' ? 'radioOn' : 'radioOff'" />
									<span>Barcode</span>
								</div>
								<div class="radio-wrapper" @click="inFocus = 'crewid'">
									<icon-component :iconName="inFocus === 'crewid' ? 'radioOn' : 'radioOff'" />
									<span>Crew ID</span>
								</div>
								<div class="radio-wrapper" @click="inFocus = 'pincode'" v-if="design === 'ecruise'">
									<icon-component :iconName="inFocus === 'pincode' ? 'radioOn' : 'radioOff'" />
									<span>PIN code</span>
								</div>
							</div>
							<!-- <label for="authorize" class="label">Barcode/Crew ID<span v-if="design === 'ecruise'">/PIN code</span></label> -->


              <span class="form-field__label">PIN code</span>

              <input
								:type="useMagneticScannerValue ? 'password' : 'text'"
								autocomplete="off"
								id="authorize"
								v-model="dataField"
								@input="handleTrim"
								@keypress="isNumber($event)"
								:placeholder="(inFocus === 'barcode') ? 'Barcode' : (inFocus === 'crewid') ? 'Crew ID' : 'PIN code'"
								class="authorize-input"
								:class="{'active': inFocus === 'crewId'}"
							>
							<base-button text="AUTHORIZE" :isDisabled="!dataField.length" classes="def-btn main-action-btn uppercase medium border-2" @onClick="login"/>
						</form>
          </div>
					<div v-if="!showScannerButton && !useMagneticScannerValue" class="scan-wrapper global-scanner">
						<div class="barcode">
							<icon-component iconName="barcode" class="barcode_img" />
							<p>or scan Crew member card</p>
						</div>
					</div>
					<div v-if="showScannerButton && !useMagneticScannerValue" class="scan-wrapper barcode-camera">
						<div class="barcode" @click="openBarcodeScannerModal">
							<icon-component iconName="barcode" class="barcode_img" />
							<p>Scan crew card with camera</p>
						</div>
					</div>
				</div>
			</div>
		</div >
		<Keypad
			v-if="!useMagneticScannerValue || secretShow"
			class="keypad"
			:dot="false"
			@clickOnKey="clickOnKey"
			@clear="clear"
		/>
	</div>
	<barcode-scanner-modal v-if="showBarcodeScannerModal" ref="barcode-scanner-modal" @submitBarcode="handleBarcode" @onModalClose="showBarcodeScannerModal = false" :openedFromLogin="true"></barcode-scanner-modal>
	<barcode-scan-interceptor @submitBarcode="handleBarcode" :openedFromLogin="true"></barcode-scan-interceptor>
</template>

<script>
import Keypad from "@/components/_shared/Keypad";
import {authService} from "@/_api/auth.api";
import store from "@/store";
import BarcodeScannerModal from "@/components/_modals/BarcodeScannerModal";
import BarcodeScanInterceptor from "@/components/_shared/BarcodeScanInterceptor";
import BaseButton from "@/components/_shared/Button.vue";
import iconComponent from "@/components/_shared/Icon.vue";
import { stopStream } from '@/_helpers/media-devices.js';

export default {
	name: 'LoginRootComponent',
	props: {},
	components: {Keypad, BarcodeScannerModal, BarcodeScanInterceptor, BaseButton, iconComponent},
	data() {
		return {
			crewId: '',
			pinCode: '',
			barcode: '',
			inFocus: 'pincode',
			dataField: '',
			showBarcodeScannerModal: false,
			showScannerButton: false,
			taps: 0,
			int: undefined,
			int2: undefined,
			secretShow: false,

      needSwitch: false,
      isSwitchProcessed: false,

      oldPosId: null,
      oldPosName: null,
		}
	},
	computed: {
		posId(){
			return this.$store.state.auth.posId
		},
		posName(){
			return this.$store.state.auth.posName;
		},
		design(){
			return this.$store.state.UI
		},
		useMagneticScannerValue() {
			return this.$store.state.settings.useMagneticScanner;
		},

    hasSelectedDepartment() {
      try {
        const posId = JSON.parse(localStorage.getItem('posId'));

        return Boolean(!!posId);
      } catch (e) {}

      return false;
    },
	},
	created() {},

	async mounted() {
		console.log(this.$store.state.settings.useMagneticScanner);
    /*this.emmiter.on('loginViaBarcode', (data) => {
      // this.barcode = data;
      this.dataField = data;
    this.login();
    });*/
    if (navigator.mediaDevices === undefined) {
      this.showScannerButton = false;
      return;
    }

    try {
      this.showScannerButton = false;
    } catch (error) {
      this.showScannerButton = false;
    }
  },

	beforeUnmount() {},
	methods: {
    async changeDepartment() {
      this.isSwitchProcessed = true;

      this.oldPosId = this.posId;
      this.oldPosName = this.posName;

      this.$store.dispatch('terminalReset');

      const payload = this.getLoginPayload();

      try {
        const { data } = await authService.login(payload);

        store.dispatch('loginUser', data);
        await this.$router.push('/pos');
      } catch (error) {
        this.$store.dispatch('setupPosId', this.oldPosId);
        this.$store.dispatch('savePosName', this.oldPosName);

        console.error(error.message);
      } finally {
        this.oldPosId = null;
        this.oldPosName = null;
        this.isSwitchProcessed = false;
      }
    },

		tap() {
			if (this.int) {
				clearTimeout(this.int);
			};
			if (this.int2) {
				clearTimeout(this.int2);
			};
			this.taps +=1;
			this.int = setTimeout(() => {
				if (this.taps < 5) {
					this.taps = 0
				};
			}, 666);
			if (this.taps >= 5) {
				this.secretShow = true;
				this.int2 = setTimeout(() => {
					this.taps = 0;
					this.secretShow = false;
				}, 30000);
			};
		},
		handleTrim() {
			this.dataField = this.dataField.trim()
		},
		isNumber: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if (charCode < 48 || charCode > 57) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
    getLoginPayload() {
      const payload = {
        posId: this.posId,
      };

      switch (this.inFocus) {
        case 'crewid':
          payload['crewId'] = this.dataField;
          break;
        case 'pincode':
          payload['pinCode'] = this.dataField;
          break;
        case 'barcode':
          payload['barcode'] = this.dataField;
          break;
      }

      return payload;
    },
		login() {
			if (!this.dataField.length) {
        return;
			}

      if (this.needSwitch) {
        this.changeDepartment();

        return;
      }

      const payload = this.getLoginPayload();

      authService.login(payload).then(res => {
        if (res) {
          store.dispatch('loginUser', res.data)
          this.$router.push('/pos');
        }
      })
        .catch((err) => {
         console.log(err.message);
        })
		},
		clickOnKey(e) {
			this.dataField += e;
		/*if (this.design === 'margaritaville') {
			//this.inFocus = 'crewId';
			this.crewId += e;
		} else {
			if (this.inFocus === 'crewId') {
				this.crewId += e
			} else if (this.inFocus === 'pinCode') {
				this.pinCode += e
			}
		}*/
		},
		clear() {
			this.dataField = this.dataField.slice(0, -1)
				/*if (this.inFocus === 'crewId') {
						this.crewId = this.crewId.slice(0, -1)
				} else if (this.inFocus === 'pinCode') {
						this.pinCode = this.pinCode.slice(0, -1)

				}*/
		},
		openBarcodeScannerModal() {
			this.showBarcodeScannerModal = true;
			this.$nextTick(() => {
				this.$refs['barcode-scanner-modal'].openModal();
			})
		},
		handleBarcode(data) {
			this.inFocus = 'barcode';
			this.dataField = data.code.toString();
			// this.barcode = data.toString();
				this.showBarcodeScannerModal = false;
			this.login();
		}
	},
	watch: {}
}
</script>

<style lang="less" scoped>
	.tap {
		position: absolute;
		top: 0;
		right: 0;
		width: 15vw;
		height: 15vh;
		background-color: transparent;
	}
	.marg-logo {
		margin-top: 50px;
		display: flex;
		justify-content: center;

    @media (max-width: 1400px) {
      margin-top: 40px;
    }

    @media (max-width: 1024px) {
      margin-top: 35px;
    }

    .margaritaville-logo {
      max-width: 743px;

      max-height: 150px;

      @media (max-width: 1400px) {
        max-height: 125px;
      }

      @media (max-width: 1024px) {
        max-height: 100px;
      }
    }
	}

	.pos-t {
		position: relative;
		top: 100px;
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		flex-wrap: nowrap;
		#pos-login-root {
			margin: 0;
		}
		.keypad {
			margin: 0;
			z-index: 1;
		}
	}
	/*.marg-t {
		display: flex;
		justify-content: space-evenly;
		align-items: center;
		flex-wrap: nowrap;
		#marg-login-root {
			margin: 0;
		}
		.keypad {
			!*width: 400px;
			bottom: 66px;*!
			margin: 0;
			z-index: 1;
		}
	}*/

	#root-wr {
		position: relative;
		background: #FFFFFF;
		box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.12);
		border-radius: 8px;
		width: 450px;
		// height: 516px;
		// margin: 70px auto 0 auto;
		padding: 24px;
		.img-wrapper {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			margin-bottom: 48px;
			.logo {
				margin: 0 auto;
				width: 120px;
				height: 108px;
			}
		}
		.auth-type {
			flex: 1 1 50%;
			position: relative;
			&:first-child {
				padding-right: 24px;
			}
			&:last-child {
				// border-left: 1px rgba(0, 0, 0, 0.1) solid;
				padding-left: 24px;
			}
			.scan-wrapper {
				border-top: 1px rgba(0, 0, 0, 0.1) solid;
				padding-top: 15px;
				&.global-scanner {
					.barcode {
						border: none;
					}
				}
				.barcode {
					display: flex;
					align-items: center;
					justify-content: center;
					border: 2px solid;
					border-radius: 8px;
					padding: 5px 10px;
					cursor: pointer;
					p {
						margin: 0 0 0 15px;
					}
				}
			}
			.auth-form-wrapper {
				margin-bottom: 20px;
				.type-radio {
					display: flex;
					justify-content: flex-start;
					gap: 24px;
					align-items: center;
					flex-wrap: nowrap;
					margin-bottom: 30px;
					width: 100%;
					.radio-wrapper {
						display: flex;
						justify-content: space-between;
						align-items: center;
						flex-wrap: nowrap;
						img {
							margin-right: 5px;
						}
					}
				}
				.title {
          font-family: "Segoe UI", sans-serif;
					font-style: normal;
					font-weight: 300;
					font-size: 42px;
					line-height: 56px;
					color: #3F8EC5;
					text-align: left;
					margin: 0 0 36px 0;
        }
				.sub-title {
					font-weight: 600;
					font-size: 12px;
					line-height: 16px;
					text-align: left;
					color: #1C282D;
					margin: 0 0 44px 0;
				}
				form {
					display: flex;
					justify-content: flex-start;
					align-items: flex-end;
					flex-wrap: wrap;
					// .label {
					// 	font-weight: 600;
					// 	font-size: 14px;
					// 	line-height: 16px;
					// 	color: #1C282D;
					// 	text-align: left;
					// 	display: block;
					// 	width: 100%;
					// }
					input {
						width: 100%;
						border: none;
						// background: #ECF4F9;
						// border-radius: 4px 4px 2px 2px;
						height: 30px;
            border-bottom: 2px solid #3F8EC5 !important;
						transition: all 200ms;
						font-size: 18px;
						line-height: 20px;
						align-items: center;
						color: #1C282D;
						padding-left: 11px;
            margin: 0 0 27px;

            &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
							color: grey;
							font-size: 12px;
							display: flex;
							justify-content: center;
							align-items: center;
							line-height: 20px;
						}
						&::-moz-placeholder { /* Firefox 19+ */
							color: grey;
							font-size: 12px;
							display: flex;
							justify-content: center;
							align-items: center;
							line-height: 20px;
						}
						&:-ms-input-placeholder { /* IE 10+ */
							color: grey;
							font-size: 12px;
							display: flex;
							justify-content: center;
							align-items: center;
							line-height: 20px;
						}
						&:-moz-placeholder { /* Firefox 18- */
							color: grey;
							font-size: 12px;
							display: flex;
							justify-content: center;
							align-items: center;
							line-height: 10px;
						}
						&.active {
							background: #FFFFFF;
							border-radius: 4px 4px 2px 2px;
							border: none;
							border-bottom: #3F8EC5 2px solid;
						}
					}
				}
				.def-btn {
					box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
					width: 100%;
					padding: 5px 20px;
					height: 36px;
          font-family: "Segoe UI", sans-serif;
				}
			}
		}
	}

	.pos-login-root {
			/*position: relative;
			background: #FFFFFF;
			box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.12);
			border-radius: 8px;
			width: 450px;
			// height: 516px;
			margin: 70px auto 0 auto;
			padding: 24px;*/
		.img-wrapper {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			.logo {
				margin: 0 auto;
				width: 120px;
				height: 108px;
			}
		}
			.flex-row {
					display: flex;
					margin-top: 36px;
					//height: 324px;
					.auth-type {
							flex: 1 1 50%;
							position: relative;
						&:first-child {
							padding-right: 24px;
						}
						&:last-child {
						// border-left: 1px rgba(0, 0, 0, 0.1) solid;
							padding-left: 24px;
						}
							.scan-wrapper {
								border-top: 1px rgba(0, 0, 0, 0.1) solid;
								padding-top: 15px;
									.barcode {
											display: flex;
											align-items: center;
										justify-content: center;
										border: 2px solid;
										border-radius: 8px;
										padding: 5px 10px;
										cursor: pointer;
										color: #3F8EC5;
										border-color: #3F8EC5;
											p {
												margin: 0;
													margin-left: 15px;
											}
									}
							}
						.auth-form-wrapper {
							margin-bottom: 20px;
							.type-radio {
								display: flex;
								justify-content: space-between;
								align-items: center;
								flex-wrap: nowrap;
								margin-bottom: 30px;
								width: 100%;
								.radio-wrapper {
									display: flex;
									justify-content: space-between;
									align-items: center;
									flex-wrap: nowrap;
									img {
										margin-right: 5px;
									}
								}
							}
							.title {
								font-style: normal;
								font-weight: normal;
								font-size: 42px;
								line-height: 56px;
								color: #3F8EC5;
								text-align: left;
								margin: 0 0 30px 0;
							}
							.sub-title {
								font-weight: 600;
								font-size: 12px;
								line-height: 16px;
								text-align: left;
								color: #1C282D;
								margin: 0 0 44px 0;
							}
							form {
								display: flex;
								justify-content: flex-start;
								align-items: flex-end;
								flex-wrap: wrap;
								.label {
									font-weight: 600;
									font-size: 14px;
									line-height: 16px;
									color: #1C282D;
									text-align: left;
									display: block;
									width: 100%;
								}
								input {
									width: 100%;
									border: none;
									background: #ECF4F9;
									border-radius: 4px 4px 2px 2px;
									height: 30px;
									margin: 4px 0 10px 0;
									border-bottom: #fff 0 solid;
									transition: all 200ms;
									font-size: 18px;
									line-height: 20px;
									align-items: center;
									color: #1C282D;
									padding-left: 11px;
									&::-webkit-input-placeholder { /* Chrome/Opera/Safari */
										color: grey;
										font-size: 12px;
										display: flex;
										justify-content: center;
										align-items: center;
										line-height: 20px;
									}
									&::-moz-placeholder { /* Firefox 19+ */
										color: grey;
										font-size: 12px;
										display: flex;
										justify-content: center;
										align-items: center;
										line-height: 20px;
									}
									&:-ms-input-placeholder { /* IE 10+ */
										color: grey;
										font-size: 12px;
										display: flex;
										justify-content: center;
										align-items: center;
										line-height: 20px;
									}
									&:-moz-placeholder { /* Firefox 18- */
										color: grey;
										font-size: 12px;
										display: flex;
										justify-content: center;
										align-items: center;
										line-height: 10px;
									}
									&.active {
										background: #FFFFFF;
										border-radius: 4px 4px 2px 2px;
										border: none;
										border-bottom: #3F8EC5 2px solid;
									}
								}
							}
							.def-btn {
								box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
								width: 100%;
								padding: 5px 20px;
								height: 40px;
							}
						}
					}
			}
	}
	.marg-login-root {
			/*position: relative;
			background: #FFFFFF;
			box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.12);
			border-radius: 8px;
			//width: 312px;
			// height: 400px;
		width: 400px;
			margin: 10px auto 0 auto;
			padding: 44px;*/
			.flex-row {
					display: flex;
					// height: 324px;
					.auth-type{
						width: 100%;
							.auth-form-wrapper {
								.title{
									font-style: normal;
									font-weight: 400;
									font-size: 42px;
									line-height: 56px;
									color: #017E8D;
									text-align: left;
								}
								.sub-title{
									font-style: normal;
									font-weight: 600;
									font-size: 12px;
									line-height: 16px;
									color: #304143;
									text-align: left;
									margin-top: -25px;
								}
								form{
									margin-top: 44px;
									.label {
										font-weight: 600;
										font-size: 14px;
										line-height: 16px;
										color: #1C282D;
										text-align: left;
										display: block;
										margin-bottom: 5px;
									}
									input {
										margin: 0 auto;
										left: 0;
										width: 100%;
										height: 30px;
										border: none;
										font-size: 18px;
										line-height: 20px;
										align-items: center;
										color: #1C282D;
										margin-bottom: 20px;
									}
									.def-btn{
										width: 100%;
										height: 40px;
									}
								}
							}
					}
					.divider{
							margin: 24px auto;
							border: none;
							border-bottom: 1px solid #000000;
							opacity: 0.1;
							width: 240px;
					}
				.scan-wrapper {
					.barcode {
						display: flex;
						align-items: center;
						justify-content: center;

						border: 2px solid;
						border-radius: 8px;
						padding: 5px 10px;
						cursor: pointer;
						color: #017E8D;
						border-color: #017E8D;
						p {
							margin: 0;
							margin-left: 15px;
						}
					}
				}
			}
	}
	.keypad {
			width: 400px;
			bottom: 66px;
			margin: 10px auto 0 auto;
	}

	@media (max-width: 1179px) {
		#pos-login-root {
			width: 60%;
		}
	}

  .auth-form {
    //margin-bottom: 15px;
  }

  .change-department-btn {
    cursor: pointer;
  }

  .current-department {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: 32px;

    &__item {
      box-sizing: border-box;

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 10px;

      border: 1px solid #E5E0EB;
      border-radius: 8px;

      width: 100%;

      font-family: 'Segoe UI',sans-serif;
      font-style: normal;
      font-weight: 600;

      * > {
        font-family: inherit;
        font-weight: inherit;
      }
    }

    &__name {
      font-size: 18px;
      line-height: 20px;
      padding: 10px 12px 13px 11px;

      display: flex;
      align-items: center;

      color: #404050;
    }

    &__switch {
      border: none;
      background: transparent;

      font-size: 14px;
      line-height: 16px;
      padding: 10px 12px 13px 11px;

      display: flex;
      align-items: center;

      color: #E86D32;

      cursor: pointer;

      opacity: 0.5;

      &.selected {
        opacity: 1;
      }
    }
  }

  .form-field__label {
    font-family: 'Segoe UI',sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;

    color: #1C282D;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding-bottom: 8px;
  }
</style>
